import { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import { supabase } from '../supabaseClient';
import { idFromSlug } from '../utils/slug';
import SEO from '../components/SEO';

export default function BlogPost() {
  const { slug } = useParams();
  const [blog, setBlog] = useState(null);
  const [loading, setLoading] = useState(true);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    let active = true;
    setLoading(true);
    setNotFound(false);
    supabase
      .from('blogs')
      .select('*')
      .eq('id', idFromSlug(slug))
      .maybeSingle()
      .then(({ data }) => {
        if (!active) return;
        if (data) setBlog(data);
        else setNotFound(true);
        setLoading(false);
      });
    return () => { active = false; };
  }, [slug]);

  if (loading) {
    return <div className="page container"><div className="loading-state">Loading post…</div></div>;
  }

  if (notFound || !blog) {
    return (
      <div className="page container">
        <SEO title="Post not found | Jowey's" description="This blog post could not be found." path={`/blog/${slug}`} />
        <div className="glass-card" style={{ maxWidth: 760, margin: '0 auto' }}>
          <h1>Post not found</h1>
          <p><Link to="/blog">Back to blog</Link></p>
        </div>
      </div>
    );
  }

  const description = blog.content.length > 155 ? `${blog.content.slice(0, 155)}…` : blog.content;
  const jsonLd = {
    '@context': 'https://schema.org',
    '@type': 'BlogPosting',
    headline: blog.title,
    articleBody: blog.content,
    datePublished: blog.created_at,
    author: { '@type': 'Person', name: 'Joan Christine Nyawira' },
  };

  return (
    <div className="page container">
      <SEO title={`${blog.title} | Jowey's Blog`} description={description} path={`/blog/${slug}`} jsonLd={jsonLd} />
      <div className="glass-card" style={{ maxWidth: 760, margin: '0 auto' }}>
        <article className="blog-post">
          <h1>{blog.title}</h1>
          <div className="blog-date">
            {blog.created_at
              ? new Date(blog.created_at).toLocaleDateString('en-KE', { dateStyle: 'long' })
              : 'No date'}
          </div>
          <div className="blog-content">{blog.content}</div>
        </article>
        <p style={{ marginTop: '1.5rem' }}><Link to="/blog">&larr; Back to all posts</Link></p>
      </div>
    </div>
  );
}
